import { render, staticRenderFns } from "./EditSeniorityModal.vue?vue&type=template&id=38dba95c&scoped=true"
import script from "./editSeniorityModal.ts?vue&type=script&lang=ts&external"
export * from "./editSeniorityModal.ts?vue&type=script&lang=ts&external"
import style0 from "./EditSeniorityModal.vue?vue&type=style&index=0&id=38dba95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dba95c",
  null
  
)

export default component.exports